window.VCA = window.VCA || {};

window.VCA.dashboardDatalayer = (function ($) {

    function init() {
        if ($('.dashboard__header').length <= 0) {
            return;
        }

        initRemindersImpressions();
        initAppointmentsImpressions();
        initRefillsImpressions();
        initVetRecommendationsImpressions();
        reminderCtaClick();
        appointmentsCtaClick();
        refillCtaClick();
        vetRecommendationsClick();
    }

    function initRemindersImpressions() {
        if ($('.js-dashboard-reminders').length <= 0) {
            return;
        }
        var reminder = [];
        $('.js-dashboard-reminders .card-listing__card').each(function (index) {
            let name = $(this).find('.js-reminder-title').text().trim();
            let petId = $(this).find('.js-reminder-title').data('petid');
            let cta = $(this).find('.js-reminder-button').text().trim();
            let date =  $(this).find('.js-reminder-date').text().trim();

            reminder.push({
                'name': name,
                'pet-id': petId,
                'cta-text': cta,
                'date': date
            });
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'dashboard-reminder-impression',
            'impressions': reminder
        });
    }

    
    function reminderCtaClick(data) {
        $('.js-dashboard-reminders').on('click', '.js-reminder-button', function (e) {
            let $card = $(this).closest('.card-listing__card');
            let name = $card.find('.js-reminder-title').text().trim();
            let petId = $card.find('.js-reminder-title').data('petid');
            let cta = $card.find('.js-reminder-button').text().trim();
            let date =  $card.find('.js-reminder-date').text().trim();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'reminder-click',
                'impressions': [{
                    'name': name,
                    'pet-id': petId,
                    'cta-text': cta,
                    'date': date
                }]
            });
        });
    }

    function initAppointmentsImpressions() {
        if ($('.js-dashboard-appointments').length <= 0) {
            return;
        }
        var appointments = [];
        $('.js-dashboard-appointments .card-listing__card').each(function (index) {
            let name = $(this).find('.js-appointments-title').text().trim();
            let petId = $(this).find('.js-appointments-title').data('petid');
            let cta = $(this).find('.js-reminder-button').data('cta-text').trim();
            let date =  $(this).find('.js-appointments-date').text().trim();

            appointments.push({
                'name': name,
                'pet-id': petId,
                'cta-text': cta,
                'date': date
            });
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'dashboard-appointments-impression',
            'impressions': appointments
        });
    }

    function appointmentsCtaClick(data) {
        $('.js-dashboard-appointments').on('click', '.js-appointments-button', function (e) {
            let $card = $(this).closest('.card-listing__card');
            let name = $card.find('.js-appointments-title').text().trim();
            let petId = $card.find('.js-appointments-title').data('petid');
            let cta = $card.find('.js-appointments-button').text().trim();
            let date =  $card.find('.js-appointments-date').text().trim();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'appointments-click',
                'impressions': [{
                    'name': name,
                    'pet-id': petId,
                    'cta-text': cta,
                    'date': date
                }]
            });
        });
    }

    function initRefillsImpressions() {
        if ($('.js-presc-refills-card').length <= 0) {
            return;
        }
        var refills = [];
        $('.js-presc-refills-card').each(function (index) {
            let name = $(this).find('.vca-card__mid__name').text().trim();
            let petId = $(this).data('petid');
            let cta = $(this).find('.js-add-to-cart .align-items-center').text().trim();
            let date =  $(this).find('.js-refill-date').text().trim();

            refills.push({
                'name': name,
                'pet-id': petId,
                'cta-text': cta,
                'list':'product refills',
                'date': date
            });
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'product-impression',
            'ecommerce': {
                    'impressions': refills
            }
        });
    }

    function refillCtaClick(data) {
        $('.cards-carousel__carousel').on('click', '.js-presc-refills-card', function (e) {
            let $card = $(this).closest('.js-presc-refills-card');
            let name = $card.find('.vca-card__mid__name').text().trim();
            let petId = $card.data('petid');
            let cta = $card.find('.js-add-to-cart .align-items-center').text().trim();
            let date =  $card.find('.js-refill-date').text().trim();

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'promotion-click',

                'ecommerce': {
                    'click': {
                        'actionField': {
                            'list': 'product refills'
                        },
                        'products': [{
                            'name': name,
                            'pet-id': petId,
                            'cta-text': cta,
                            'date': date
                        }]
                    }
                }
            });
        });
    }

    function initVetRecommendationsImpressions() {
        if ($('.js-vet-recommendations-card').length <= 0) {
            return;
        }
        var recommendations = [];
        $('.js-vet-recommendations-card').each(function (index) {
            let name = $(this).data('item-name');
            let id = $(this).data('item-id');
            let price = $(this).data('item-price');
            let brand = $(this).data('item-brand');
            let category = $(this).data('item-category');
            let position = index + 1;

            recommendations.push({
                'name': name,
                'id': id,
                'list': 'vet recommendations',
                'category': category,
                'brand': brand,
                'price': price,
                'position': position
            });
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'product-impression',
            'ecommerce': {
                'impressions': recommendations
            }
        });
    }


    function vetRecommendationsClick(data) {
        $('.js-vet-recommendations-card').on('click', '.js-vet-recommendations-card-btn', function (e) {
            let $card = $(this).closest('.js-vet-recommendations-card');
            let name = $card.data('item-name');
            let id = $card.data('item-id');
            let price = $card.data('item-price');
            let brand = $card.data('item-brand');
            let category = $card.data('item-category');
            let position =  $card.index() + 1;
            let cta = $(this).text().trim();

             window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'product-click',
                    'ecommerce': {
                        'click': {
                            'actionField': {
                                'list': 'vet recommendations'
                            },
                            'products': [{
                                'name': name,
                                'id': id,
                                'list': 'vet recommendations',
                                'category': category,
                                'brand': brand,
                                'price': price,
                                'cta-text': cta,
                                'position': position
                            }]
                        }
                    }
                });
        });
    }


    return {
        init: init
    };



})(jQuery);

$(function () {
    VCA.dashboardDatalayer.init();
});